// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
import { getStorage } from "firebase/storage"


// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyB3pYbgqlZSjSsFmZG4zwLeQUUaX9Trxcg",
  authDomain: "namasvi-5d515.firebaseapp.com",
  databaseURL: process.env.REACT_APP_FIREBASE_DATABASE_URL || "https://namasvi-5d515-default-rtdb.asia-southeast1.firebasedatabase.app",
  projectId: "namasvi-5d515",
  storageBucket: "namasvi-5d515.appspot.com",
  messagingSenderId: "226556767471",
  appId: "1:226556767471:web:d121b5133060e766273f1a",
  measurementId: "G-MXD2CK0EFZ"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const storage = getStorage(app);
const analytics = getAnalytics(app);

export { storage, analytics }